import { useLoaderStore } from '../stores';

export const useLoader = () => {
    const isLoading = useLoaderStore(state => state.isLoading);
    const setIsLoading = useLoaderStore(state => state.setIsLoading);

    return { isLoading, setIsLoading };
};
